import ReactSelect from '../baseInputs/react-select'

type Props = {
  options: Array<{ label: string; value: string }>
  helper?: string
  optional?: boolean
  inputName?: string
  onChange?: (value: string) => void
}

const Occupation = ({ options, inputName, ...rest }: Props) => {
  const name = inputName || 'occupation'
  const label = 'Occupation'

  return <ReactSelect name={name} label={label} options={options} {...rest} />
}

export default Occupation
